import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DynamicComponent } from '@dice/app/types/dynamic-component.type';
import { ButtonContent } from '@dice/app/types/table.types';

@Component({
  selector: 'table-buttons-group',
  templateUrl: './table-buttons-group.component.html',
  standalone: false,
})
export class TableButtonsGroupComponent<T> implements OnChanges {
  @Input() element: T;

  @Input() buttons?: ButtonContent[];

  @Input() isHeader?: boolean;

  @Input() columnCssClass?: string; // unused, fixes console error after angular update

  @Input() cssClass?: string; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  static readonly sortEnabled = false;

  dynamicComponents: DynamicComponent[];

  constructor() {
    this.dynamicComponents = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { buttons, element } = changes;
    if (!!buttons && buttons.firstChange && !!element) {
      this.createDynamicComponents();
    }
  }

  private createDynamicComponents(): void {
    this.buttons.forEach((button: ButtonContent) => {
      const inputs = {
        ...button,
        isHeader: this.isHeader,
        element: this.element,
      };
      const outputs = {};
      this.dynamicComponents.push({ component: button.type, inputs, outputs });
    });
  }
}
